jQuery(function($) {

  let $bio_body = $('body');
  let $close_bio = undefined;
  let $tab_bookmark;

  // Close Modal
  function closeBioModal($prev_focus) {
    let $modal_bio = $('.bio-modal');
    $modal_bio.remove();
    $bio_body.removeClass('blur');
    $close_bio = undefined;
    $prev_focus.focus();
    location.hash = '';
  }

  // Open Modal
  $('.JS-open-bio').click(function() {
    let $modal_bio = $('.bio-modal');
    $modal_bio.remove();
    let $current_bio = $(this).parent().parent().parent();
    let $modal_content = $current_bio.clone();
    $tab_bookmark = $(this);
    location.hash = $(this).attr('id');

    if ($(window).width() > 768) {
      $bio_body.addClass('blur');
    }

    $('.bio-listing').append('<div class="bio-modal"></div>');
    $('.bio-modal').append($modal_content.addClass('bio-item-opened'));
    $('.bio-item-opened').attr('id', 'bio-modal');

    $close_bio = $modal_content.find('button').first();
    $close_bio.attr('id', 'close-bio');
    $close_bio = $('#close-bio');
    $close_bio.focus();

    $(window).keydown(function(e) {
      if ($close_bio !== undefined) {
        if (e.which === 9) {
          e.preventDefault();
          $close_bio.focus();
        }
      }
    });

    // When the user clicks anywhere outside of the modal, close it
    $('.bio-modal').click(function(e) {
      if (e.target.closest('#bio-modal') === null) {
        closeBioModal($tab_bookmark);
      }
    });

    // Add Listener to newly created element to remove modal onces close is clicked
    $('.js-close-bio').click(function() {
      closeBioModal($tab_bookmark);
    });
  });

  $(document).keydown(function(event) {
    if (event.keyCode === 27) {
      closeBioModal($tab_bookmark);
    }
  });

  $(window).on('load', function() {
    let hash = $(location).attr('hash').replace('#', '');
    if ($('#' + hash)) {
      $('#' + hash.toLowerCase()).click();
    }
  });
});
